import { PLATFORM_PARTNER_ID } from 'src/constants/platform';
import { mapUIActionsForRequest } from 'src/graphql/entities/behavior';
import { parseJsonSafely } from 'src/utils/objects';
import { FetchedMacroRaw, Macro, MacroAction } from './macro';
import { MacrosFormFields, MacrosFormModel, MacroVisibility } from './macro.types';

export function mapFormValuesToMacrosRequest(values: MacrosFormModel, partnerId: number) {
  /**
   * Every action for now can only have a single rule, although it is using
   * react-querybuider component which creates groups of rules, allowing
   * to have multiple rules for a single action.
   */
  const requestActions = values.actions.map(mapUIActionsForRequest);

  return {
    partnerId,
    name: values.name,
    description: values.description,
    template: values.template,
    actions: JSON.stringify(requestActions),
    messagePrivacy: values.messagePrivacy,
    public: values[MacrosFormFields.Visibility] !== MacroVisibility.OnlyMe,
  };
}

export function mapMacroResponseToUI(macro: FetchedMacroRaw): Macro {
  const conversationAssigneeGroups = (macro.conversationAssigneeGroups || []).map((group) => ({
    id: group.id,
    value: group.id,
    label: group.name,
    partnerId: macro.partnerId,
  }));

  return {
    id: macro.macroId,
    name: macro.name,
    description: macro.description,
    template: macro.template,
    public: macro.public,
    actions: parseJsonSafely<MacroAction[]>(macro.actions) || [],
    messagePrivacy: macro.messagePrivacy,
    isDefault: macro.partnerId === PLATFORM_PARTNER_ID,
    partnerId: macro.partnerId,
    createdBy: macro.createdBy,
    conversationAssigneeGroups,
    createdAt: macro.createdAt,
    updatedAt: macro.updatedAt,
  };
}
